import { render } from "./PhotoSphereViewer.vue?vue&type=template&id=5744d589&scoped=true&ts=true"
import script from "./PhotoSphereViewer.vue?vue&type=script&lang=ts"
export * from "./PhotoSphereViewer.vue?vue&type=script&lang=ts"

import "./PhotoSphereViewer.vue?vue&type=style&index=0&id=5744d589&scoped=true&lang=css"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5744d589"]])

export default __exports__